import { getAgencyBusinessModelFilterInput } from 'stores/adapters/bex-api/search/filters/agency-business-model-filter-input';
import { getCommissionTierFilterInput } from 'stores/adapters/bex-api/search/filters/commission-tier-filter-input';
import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

import { getStructureTypesInput } from './structure-types-input';

import { getAccessibilityInput } from './accessibility-input';
import { getAmenitiesInput } from './amenities-input';
import { getBedroomFilterInput } from './bedroom-filter-input';
import { getChainInput } from './chain-input';
import { getCleaningAndSafetyPracticesInput } from './cleaning-and-safety-practices-input';
import { getDealsFilterInput } from './deals-filter-input';
import { getMealPlanFilterInput } from './meal-plan-filter-input';
import { getNeighborhoodInput } from './neighborhood-input';
import { getPaymentTypeInput } from './payment-type-input';
import { getPointOfInterestInput } from './point-of-interest-input';
import { getPropertyNameInput } from './property-name-input';
import { getPropertyStyleInput } from './property-style-input';
import { getReviewScoreRangeInput } from './review-score-filter-input';
import { getRewardsFilterInput } from './rewards-filter-input';
import { getStarFilterInput } from './star-filter-input';
import { getTravelerTypeInput } from './traveler-type-input';
import { PropertySearchFiltersInput } from '__generated__/api';

export const getFiltersInput = (searchCriteria: SearchCriteriaModel, sortAndFilterOptions: any): PropertySearchFiltersInput => {
  const starList = getStarFilterInput(searchCriteria);
  const structureTypes = getStructureTypesInput(searchCriteria);
  const propertyName = getPropertyNameInput(searchCriteria);
  const neighborhood = getNeighborhoodInput(searchCriteria);
  const amenities = getAmenitiesInput(searchCriteria);
  const accessibility = getAccessibilityInput(searchCriteria);
  const travelerType = getTravelerTypeInput(searchCriteria);
  const reviewScore = getReviewScoreRangeInput(searchCriteria, sortAndFilterOptions);
  const poi = getPointOfInterestInput(searchCriteria);
  const paymentType = getPaymentTypeInput(searchCriteria);
  const cleaningAndSafetyPractices = getCleaningAndSafetyPracticesInput(searchCriteria);
  const deals = getDealsFilterInput(searchCriteria);
  const propertyStyles = getPropertyStyleInput(searchCriteria);
  const bedroomFilter = getBedroomFilterInput(searchCriteria);
  const rewards = getRewardsFilterInput(searchCriteria);
  const commissionTiers = getCommissionTierFilterInput(searchCriteria);
  const agencyBusinessModels = getAgencyBusinessModelFilterInput(searchCriteria);
  const mealPlan = getMealPlanFilterInput(searchCriteria);
  const chain = getChainInput(searchCriteria);

  return {
    starList,
    structureTypes,
    propertyName,
    neighborhood,
    mealPlan,
    amenities,
    accessibility,
    travelerType,
    reviewScore,
    poi,
    paymentType,
    cleaningAndSafetyPractices,
    deals,
    propertyStyles,
    rewards,
    bedroomFilter,
    commissionTiers,
    agencyBusinessModels,
    chain,
  };
};
